const getWebShopEndpoint = (org: string) => {
  return `https://shop.${org}.premium-control.jp/shop/login`;
};

export { getWebShopEndpoint };
